import Model from '../Model'

export default class Video extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/videos'
    }
}
